/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  CssBaseline,
  Grid,
  Rating,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import useStyles from '../../../../assets/styles/pages/Request';
import Header from '../../../../components/Header';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import { ReactComponent as IconStartLinear } from '../../../../assets/images/svg/shops/icon_star_linear.svg';
import { ReactComponent as IconStartBold } from '../../../../assets/images/svg/shops/icon_star_bold.svg';
import { ReactComponent as IconObservation } from '../../../../assets/images/svg/shops/request/icon_observacao.svg';

import { useLoadingContext } from '../../../../providers/use-loading';
import { useSignInContext } from '../../../../providers/use-signin';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import { getStorege } from '../../../../helpers/db_storage';
import { ModalMessage } from '../../../../components/Modal/Message';

const RequestRate: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { data, signingOut } = useSignInContext();
  let { params }: any = useParams();
  const navigate = useNavigate();
  params = window.atob(params);
  params = JSON.parse(params);
  const { idPedido, idRestaurante, dsNome, dtPedido, idEntregador } = params;

  const id_request = idPedido;
  const id_shop = idRestaurante;
  const des_shop_name = dsNome;
  const des_request_date = dtPedido;
  const id_delivery_man = idEntregador;

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const [qualityProduct, setQualityProduct] = useState<number | any>(0);
  const [qualityDelivery, setQualityDelivery] = useState<number | any>(0);
  const [qualityDeliveryMan, setQualityDeliveryMan] = useState<number | any>(0);
  const [comment, setComment] = useState<string>('');
  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [errorInfo, setErrorInfo] = useState('');

  const dataUserStorageOrder = getStorege(
    '@mais/delivery/authorization/orders',
  );

  const handleSendRate = async () => {
    if (qualityProduct <= 0 && qualityDelivery <= 0) {
      setOpenUserNotParams(true);
      setErrorInfo('Selecione a nota nos 2 critérios antes de enviar');
      return;
    }
    createloading(true);
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getRequest({
        nr_operacao: 23,
        idUsuario: data.user?.idUsuario || dataUserStorageOrder?.idUsuario,
        idRestaurante: id_shop,
        idPedido: id_request,
        vlQualidade: qualityProduct,
        vlRapidez: qualityDelivery,
        vlNotaEntregador: qualityDeliveryMan,
        idEntregador: id_delivery_man,
        dsComentario: comment,
      });

      if (result.data?.retorno == 'OK') {
        toast.success('Avaliação enviada com sucesso!');
        handleToPage('/dashboard/user/request');
        return;
      }
      toast.error('Ocorreu um erro ao enviar sua avaliação!');
      return;
    } catch (error: any) {
      if (error.response.status === 401) {
        signingOut({
          http_status: 401,
          location: 'listAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao enviar sua avaliação');
      }
    } finally {
      createloading(false);
    }
  };

  const closeModal = async () => {
    await new Promise((resolve) => {
      setTimeout(resolve, 5000);
    });
    setOpenUserNotParams(false);
  };

  useEffect(() => {
    if (openUserNotParams) {
      closeModal();
    }
  }, [openUserNotParams]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="UserDetailRequestRate" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        marginBottom="150px"
      >
        <Grid
          textAlign="center"
          justifyContent="center"
          className={classeStyle.gridTitleId}
        >
          <h5
            className={classeStyle.textTitleId}
            style={{ textTransform: 'uppercase' }}
          >
            Avaliar estabelecimento
          </h5>
          <h5 style={{ margin: '8px 0px' }}>{des_shop_name}</h5>
          <p
            className={classeStyle.textShopLight}
            style={{ textAlign: 'center' }}
          >
            Data do Pedido:{' '}
            {moment(des_request_date, 'DD/MM/YYYY HH:mm:SS').format('lll')}
          </p>
        </Grid>
        <Grid container justifyContent="center" marginTop="15px">
          <Grid item xs={12} container justifyContent="center">
            <Typography
              className={classeStyle.textShopLight}
              component="legend"
            >
              Qualidades dos Produtos
            </Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <Rating
              emptyIcon={<IconStartLinear width={30} height={30} />}
              icon={<IconStartBold width={30} height={30} />}
              name="product-controlled"
              value={qualityProduct}
              onChange={(event, newValue) => {
                setQualityProduct(newValue);
              }}
            />
          </Grid>
        </Grid>

        <Grid container justifyContent="center" marginTop="15px">
          <Grid item xs={12} container justifyContent="center">
            <Typography
              className={classeStyle.textShopLight}
              component="legend"
            >
              Rapidez da Entrega
            </Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <Rating
              emptyIcon={<IconStartLinear width={30} height={30} />}
              icon={<IconStartBold width={30} height={30} />}
              name="delivery-controlled"
              value={qualityDelivery}
              onChange={(event, newValue) => {
                setQualityDelivery(newValue);
              }}
            />
          </Grid>
        </Grid>

        <Grid container justifyContent="center" marginTop="15px">
          <Grid item xs={12} container justifyContent="center">
            <Typography
              className={classeStyle.textShopLight}
              component="legend"
            >
              Atendimento do Entregador
            </Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <Rating
              emptyIcon={<IconStartLinear width={30} height={30} />}
              icon={<IconStartBold width={30} height={30} />}
              name="delivery-controlled"
              value={qualityDeliveryMan}
              onChange={(event, newValue) => {
                setQualityDeliveryMan(newValue);
              }}
            />
          </Grid>
        </Grid>
        <Grid className={classeStyle.gridObservationMain}>
          <Grid className={classeStyle.gridObservation}>
            <IconObservation />
            <h4 className={classeStyle.titleObservation}>Alguma observação?</h4>
          </Grid>
          <hr className={classeStyle.hr} />

          <Grid>
            <textarea
              className={classeStyle.textArea}
              placeholder=""
              onChange={(e) => setComment(e.target.value)}
            />
          </Grid>
        </Grid>
        <Button
          className={classeStyle.btnSubmit}
          type="submit"
          variant="contained"
          style={{ width: '80%', position: 'fixed', bottom: 80 }}
          onClick={handleSendRate}
        >
          <p className={classeStyle.textBtnSubmit}>Continuar</p>
        </Button>
      </Grid>
      <ModalMessage
        open={openUserNotParams}
        onClose={() => setOpenUserNotParams(false)}
        title="Atenção!"
        description={errorInfo}
        primaryText="Ok"
        primaryAction={() => ''}
      />

      <FooterMenuMain children="Request" />
    </Container>
  );
};

export default RequestRate;
